export default __webpack_public_path__ + "static/media/quiz-pic-7.72685611.jpeg";